module.exports = __webpack_public_path__ + "static/media/Icon_ZoomReset.5b591c67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_ZoomReset.svg
// module id = 2324
// module chunks = 0